import { NativeRequestType } from "./constants";

class NativeApi {

    getVisitorId() {
        return "";
    }

    getAppVersion() {
        return "";
    }

    async getSessionId() {
        try {
            const requestData = this.addCommonFields(null, NativeRequestType.GET_SESSION_ID);
            postMessage(requestData);
        }
        catch (err) {
            console.error(err);
            return {};
        }
    }

    logHanselEvent() {
        throw Error("Not Implemented");
    }

    postMessage(data) {
        const request = JSON.stringify(data);
        window.ReactNativeWebView.postMessage(request);
    }

    async getHeaders(payload) {
        const requestData = this.addCommonFields(payload, NativeRequestType.GET_HEADERS);
        postMessage(requestData);
        return {};
    }

    closeWebView() {
        const requetsData = this.addCommonFields(null, NativeRequestType.CLOSE_WEB_VIEW);
        postMessage(requetsData);
    }

    getHeaderVersion() {
        throw new Error('Method not implemented')
    }
    copyToClipBoard(text) {
        if (window.MyAirtelAppReact) {
            window.MyAirtelAppReact?.copyToClipBoard(text);
        }
    }

    sendBranchAnalytics(payload) {
        const requestData = this.addCommonFields(payload, NativeRequestType.BRANCH_INTEGRATION_EVENT);
        postMessage(requestData);
    }

    addCommonFields(payload, type) {
        return {
            type,
            payload,
            // id: uuidv4(),
            // successCallBackFnName: successCallBackFnName,
            // errorCallBackFnName: errorCallBackFnName
        }
    }

}

const nativeApiInstance = new NativeApi();

export {
    nativeApiInstance
}



